import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SupportedLocale, localeFromPathname, withLocale, stripLocalePrefix } from '@/i18n/locales';
import './LanguageToggle.scss';

const LANGUAGES: { code: SupportedLocale; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
  { code: 'fr', label: 'FR' },
];

const LanguageToggle: React.FC = () => {
  const { t } = useTranslation();
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const currentLang = localeFromPathname(pathname);
  const strippedPath = stripLocalePrefix(pathname);

  const handleChange = (code: SupportedLocale) => {
    const target = withLocale(code, strippedPath) + search + hash;
    navigate(target);
  };

  return (
    <div className="lang-toggle" role="group" aria-label={t('languageToggle.ariaLabel')}>
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          className={`lang-toggle__btn${currentLang === lang.code ? ' lang-toggle__btn--active' : ''}`}
          onClick={() => handleChange(lang.code)}
          aria-pressed={currentLang === lang.code}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;
